export default __webpack_public_path__ + "static/media/nativityofblessedvirgin.4db55c2c.jpg";